import { Button, Divider } from '@dsg-tech/homefield-react';
import useLogger from 'hooks/useLogger';
import {
  HomefieldIconAppleSignIn,
  HomefieldIconGoogleSignIn,
  HomefieldIconStarPointer,
} from '@dsg-tech/homefield-react-icons';
import SignInButton from './SignInButton';
import { KEY_CODES } from '../../../../../utility/constants';

const SignedOutState = () => {
  const { error } = useLogger();
  const handleLogin = (signIn?: string) => {
    const authFunctionsMap: { [key: string]: () => Promise<void> } = {
      join: window.authFunctions.createAccount,
      google: window.authFunctions.loginWithGoogle,
      apple: window.authFunctions.loginWithApple,
      default: window.authFunctions.login,
    };

    const authFunction = authFunctionsMap[signIn ?? 'default'];

    authFunction().catch((e: any) => {
      error('SignedOutState', { ErrorMessage: 'Could not login user', Error: e });
    });
  };

  return (
    <div className="hmf-px-m hmf-py-s my-account-signed-out">
      <p className="hmf-header-bold-xl hmf-m-0">Welcome to DICK&apos;s!</p>
      <p className="hmf-subheader-m sub-header-text">
        Sign In to start earning ScoreCard Points and enjoy Free Shipping.
      </p>
      <div className="hmf-mt-s sign-in-button-container">
        <Button
          variant="primary"
          label="Sign in to my account"
          text="SIGN IN"
          className="sign-in-button hmf-py-s hmf-px-l"
          onClick={() => {
            handleLogin();
          }}
          onKeyDown={(event) => {
            if (event.keyCode === KEY_CODES.SPACE || event.keyCode === KEY_CODES.ENTER) {
              handleLogin();
            }
          }}
        />
        <div className="hmf-mt-xxs">
          <Button
            variant="secondary"
            label="Join now"
            text="JOIN NOW"
            className="sign-in-button hmf-py-s hmf-px-l"
            onClick={() => {
              handleLogin('join');
            }}
            onKeyDown={(event) => {
              if (event.keyCode === KEY_CODES.SPACE || event.keyCode === KEY_CODES.ENTER) {
                handleLogin('join');
              }
            }}
          />
        </div>
      </div>
      <div className="hmf-display-flex hmf-align-items-center hmf-my-m divider-container">
        <Divider topMargin="xs" bottomMargin="xs" />
        <span className="hmf-px-xxs hmf-subheader-bold-m divider-text hmf-text-align-center">
          or continue with
        </span>
        <Divider topMargin="xs" bottomMargin="xs" />
      </div>
      <div className="hmf-display-flex sign-in-button-container">
        <SignInButton
          label="Sign in with Google"
          icon={<HomefieldIconGoogleSignIn height={20} width={20} />}
          onClickHandler={() => {
            handleLogin('google');
          }}
        />
        <span className="hmf-ml-xxs" />
        <SignInButton
          label="Sign in with Apple"
          icon={<HomefieldIconAppleSignIn height={20} width={20} />}
          onClickHandler={() => {
            handleLogin('apple');
          }}
        />
      </div>
      <p className="hmf-legal-s hmf-mt-xs hmf-mb-s sub-header-text policy-container">
        By clicking to continue with Google or Apple above, I am agreeing to the{' '}
        <a
          href="https://www.dickssportinggoods.com/s/policy/terms-of-use"
          target="_blank"
          aria-label="Navigate to Terms of use policy">
          DICK&apos;S Terms of Use
        </a>
        ,{' '}
        <a
          href="https://www.dickssportinggoods.com/s/policy/privacy-policy"
          target="_blank"
          aria-label="Navigate to privacy policy">
          Privacy Policy
        </a>{' '}
        and{' '}
        <a
          href="https://www.dickssportinggoods.com/s/score-card-terms"
          target="_blank"
          aria-label="Navigate to Scorecard terms and conditions">
          ScoreCard Terms and Conditions
        </a>
        .
      </p>
      <section className="hmf-py-s">
        <div className="hmf-mb-s">
          <div className="hmf-display-flex hmf-align-items-center">
            <HomefieldIconStarPointer width={16} height={16} />
            <p className="hmf-header-bold-xs hmf-pl-xxxs hmf-m-0">Earn Points on Your Purchase</p>
          </div>
          <p className="hmf-subheader-s hmf-m-0 hmf-pt-xxxs sub-header-text">
            Earn 1 pt for every $1 spent. 300 Pts = $10 Reward!
          </p>
        </div>
        <div className="hmf-mb-s">
          <div className="hmf-display-flex hmf-align-items-center">
            <HomefieldIconStarPointer width={16} height={16} />
            <p className="hmf-header-bold-xs hmf-pl-xxxs hmf-m-0">Free Shipping</p>
          </div>
          <p className="hmf-subheader-s hmf-m-0 hmf-pt-xxxs sub-header-text">
            On orders $49 or more.{' '}
            <a
              href="https://www.dickssportinggoods.com/s/clearance-promo/shipping-value-promo-details"
              target="_blank"
              className="hmf-text-decoration-underline sub-header-text"
              aria-label="Navigate to Shipping details">
              Details
            </a>
            .
          </p>
        </div>
        <div className="hmf-mb-s">
          <div className="hmf-display-flex hmf-align-items-center">
            <HomefieldIconStarPointer width={16} height={16} />
            <p className="hmf-header-bold-xs hmf-pl-xxxs hmf-m-0">
              Fast Checkout & Easy Order Tracking
            </p>
          </div>
          <p className="hmf-subheader-s hmf-m-0 hmf-pt-xxxs sub-header-text">
            Save your preferences and stay updated on orders.
          </p>
        </div>
        <div className="hmf-mb-s">
          <div className="hmf-display-flex hmf-align-items-center">
            <HomefieldIconStarPointer width={16} height={16} />
            <p className="hmf-header-bold-xs hmf-pl-xxxs hmf-m-0">
              Exclusive Access to Products & Offers
            </p>
          </div>
          <p className="hmf-subheader-s hmf-m-0 hmf-pt-xxxs sub-header-text">
            Earn 1 pt for every $1 spent. 300 Pts = $10 Reward!
          </p>
        </div>
      </section>
    </div>
  );
};

export default SignedOutState;
